<template>
    <div style="margin:130px auto;">
        <div class="login-title"><img src="@/assets/img/logo.png" /></div>
        <el-form ref="loginForm" :model="form" :rules="rules" class="login-box" v-show="islogin" :style="{'animation':islogin?'realanima 2s,light 2s infinite linear alternate':''}">
            <el-form-item label="" prop="username">
                <el-input type="text" placeholder="请输入账号" v-model="form.username" suffix-icon="el-icon-user" class="login-input" @keyup.enter.native="onSubmit('loginForm')" />
            </el-form-item>
            <el-form-item label="" prop="password">
                <el-input type="password" placeholder="请输入密码" v-model="form.password" suffix-icon="el-icon-lock" class="login-input" @keyup.enter.native="onSubmit('loginForm')" />
            </el-form-item>
            <el-form-item align="center">
                <el-checkbox v-model="isRememberPass" checked style="margin-right:20px;">记住密码</el-checkbox> <a class="subbtn" @click="back()">注册新用户</a>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" round v-on:click="onSubmit('loginForm')">登  录</el-button>
            </el-form-item>
            <p class="copyinfo">© 华夏安健物联科技(青岛)有限公司</p>
        </el-form>

        <el-form ref="registerForm" :model="regform" :rules="rules" class="login-box" v-show="!islogin" :style="{'animation':!islogin?'realanima 2s,light 2s infinite linear alternate':''}">
            <el-form-item label="" prop="UserName">
                <el-input type="text" placeholder="请输入账号" v-model="regform.UserName" suffix-icon="el-icon-user" class="login-input" @keyup.enter.native="onSubmit('registerForm')" />
            </el-form-item>
            <el-form-item label="" prop="Password">
                <el-input type="password" placeholder="请输入密码" v-model="regform.Password" suffix-icon="el-icon-lock" class="login-input" @keyup.enter.native="onSubmit('registerForm')" />
            </el-form-item>
            <el-form-item label="" prop="Password2">
                <el-input type="password" placeholder="请再次输入密码" v-model="regform.Password2" suffix-icon="el-icon-lock" class="login-input" @keyup.enter.native="onSubmit('registerForm')" />
            </el-form-item>
            <el-form-item label="" prop="RealName">
                <el-input type="text" placeholder="请输入姓名" v-model="regform.RealName" suffix-icon="el-icon-office-building" class="login-input" @keyup.enter.native="onSubmit('registerForm')" />
            </el-form-item>
            <el-form-item label="" prop="Tel">
                <el-input type="text" placeholder="请输入手机号码" v-model="regform.Tel" suffix-icon="el-icon-mobile-phone" class="login-input" @keyup.enter.native="onSubmit('registerForm')" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" round v-on:click="onSubmit('registerForm')">注  册</el-button>
            </el-form-item>
            <el-form-item style="text-align:center;">
                <a class="subbtn" @click="back()">返回登录</a>
            </el-form-item>
            <p class="copyinfo">© 华夏安健物联科技(青岛)有限公司</p>
        </el-form>
    </div>
</template>

<script>
    import md5 from 'js-md5';
    import { Base64 } from 'js-base64';
    import { userLogin, newEntity } from '@/api/utils';
    import { Loading } from 'element-ui';

    export default {
        name: "Login",
        data() {
            const validatePass = (rule, value, callback) => {
                const reg = /^(?=.*[a-z])(?=.*[A-Z])[^]{8,}$/;
                if (value === '' || value === undefined || value == null) {
                    callback();
                } else {
                    if ((!reg.test(value)) && value !== '') {
                        callback(new Error('密码不少于8个字符且必包含大、小写字母'));
                    } else {
                        callback();
                    }
                }
            };
            const validatePass2 = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请再次输入密码"));
                } else if (value !== this.regform.Password) {
                    callback(new Error("两次输入密码不一致"));
                } else {
                    callback();
                }
            };
            const validatePhone = (rule, value, callback) => {
                const reg = /^[1][3,4,5,7,8][0-9]{9}$/;
                if (value === '' || value === undefined || value == null) {
                    callback();
                } else {
                    if ((!reg.test(value)) && value !== '') {
                        callback(new Error('请输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }
            };
            //const validateEMail = (rule, value, callback) => {
            //    const reg = /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/;
            //    if (value == '' || value == undefined || value == null) {
            //        callback();
            //    } else {
            //        if (!reg.test(value)) {
            //            callback(new Error('请输入正确的邮箱地址'));
            //        } else {
            //            callback();
            //        }
            //    }
            //};
            return {
                islogin: true,
                isRememberPass:true,
                form: {
                    username: '',
                    password: '',
                },
                regform: {
                    UserName: '',
                    Password: '',
                    Password2: '',
                    Tel: '',
                    RealName: ''
                },
                // 表单验证，需要在 el-form-item 元素中增加 prop 属性
                rules: {
                    UserName: [
                        { required: true, message: '用户名不能为空', trigger: 'blur' }
                    ],
                    Password: [
                        { required: true, message: '密码不能为空', trigger: 'blur' }, { validator: validatePass, trigger: "blur" }
                    ],
                    Password2: [
                        { required: true, message: '重复输入密码不能为空', trigger: 'blur' }, { validator: validatePass2, trigger: "blur" }
                    ],
                    Tel: [
                        { required: true, message: '手机号码不能为空', trigger: 'blur' }, { validator: validatePhone, trigger: "blur" }
                    ],
                    RealName: [
                        { required: true, message: '真实姓名不能为空', trigger: 'blur' }
                    ]
                    //email: [
                    //    { validator: validateEMail, trigger: "blur" }
                    //],
                }
            }
        },
        methods: {
            back() {
                this.islogin = !this.islogin;
            },
            getRememberPassword() {
                let rememberLoginInfo = localStorage.getItem('rememberLoginInfo') ? JSON.parse(localStorage.getItem('rememberLoginInfo')) : {};
                this.form.username = rememberLoginInfo.username ? rememberLoginInfo.username : '';
                this.form.password = rememberLoginInfo.password ? Base64.decode(rememberLoginInfo.password) : '';
            },
            setRememberPassword(username,password) {
                let rememberLoginInfo = {
                    username: username,
                    password:password
                };
                localStorage.removeItem('rememberLoginInfo');
                if (this.isRememberPass) {
                    localStorage.setItem('rememberLoginInfo', JSON.stringify(rememberLoginInfo));
                }
            },
            onSubmit(formName) {
                // 为表单绑定验证功能
                this.$refs[formName].validate((valid) => {
                    let that = this;
                    let params = {};
                    if (formName === "loginForm") {
                        if (valid) {
                            let loadingInstance = Loading.service({ background: 'rgba(0, 0, 0, 0.7)' });
                            params = {
                                userName: this.form.username,
                                pwd: md5(this.form.password)
                            };
                            userLogin(params).then((_resData) => {
                                loadingInstance.close();
                                if (_resData.Code === 1) {
                                    that.$message({
                                        message: _resData.Msg,
                                        type: 'success'
                                    });
                                    let loginInfo = {
                                        token: _resData.Data.token,
                                        refreshToken: _resData.Data.refreshToken,
                                        name: that.form.username,
                                        menu: JSON.parse(_resData.Data.menu),
                                        toolbar: JSON.parse(_resData.Data.toolbar),
                                        avatar: ''
                                    };
                                    that.$store.commit('user/SET_LOGININFO', loginInfo);
                                    that.setRememberPassword(that.form.username, Base64.encode(that.form.password));
                                    that.$router.push({ name: loginInfo.page === "" || loginInfo.page == null ? "index" : loginInfo.page }).catch(() => { });
                                } else {
                                    that.$message.error(_resData.Msg);
                                }
                            });
                        } else {
                            this.$message.error("用户名或密码不为空");
                            return false;
                        }
                    }
                    else if (formName === "registerForm") {
                        if (valid) {
                            let loadingInstance = Loading.service({ background: 'rgba(0, 0, 0, 0.7)' });
                            params = {
                                UserName: this.regform.UserName,
                                Password: md5(this.regform.Password),
                                Tel: this.regform.Tel,
                                RealName: this.regform.RealName
                            };
                            newEntity('User', [params]).then((_resData) => {
                                loadingInstance.close();
                                if (_resData.Code === 1) {
                                    that.$message({
                                        message: _resData.Msg == null ? "恭喜您注册成功" : _resData.Msg,
                                        type: 'success'
                                    });
                                    //赋值给loginform
                                    that.form.username = that.regform.UserName;
                                    that.form.password = that.regform.Password;
                                    //清空regform
                                    that.regform = {
                                        UserName: '',
                                        Password: '',
                                        Password2: '',
                                        Tel: '',
                                        RealName: ''
                                    };
                                    //打开登录窗口
                                    that.islogin = true;
                                } else {
                                    that.$message.error(_resData.Msg);
                                }
                            });
                        } else {
                            this.$message.error("请检查输入");
                            return false;
                        }
                    }
                });
            }
        },
        mounted() {
            document.title = "华夏安健水质溯源系统-用户登录";
            //读取记住用户名和密码
            this.getRememberPassword();
        },
        beforeRouteEnter(to, from, next) {
            window.document.body.style.background = "url('" + require("@/assets/img/login_bg.jpg") + "') no-repeat center center";
            window.document.body.style.backgroundSize = "100%";
            next();
        },
        beforeRouteLeave(to, from, next) {
            window.document.body.style.background = "";
            next();
        }
    }
</script>

<style>
    .login-box {
        width: 320px;
        margin: 0 auto;
        padding: 40px 35px 10px 35px;
        border-radius: 5px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        box-shadow: 0 0 15px #7e8084;
        animation: light 2s infinite linear alternate;
    }

    @keyframes light {
        from {
            box-shadow: 0 0 15px rgba(126,128,132,1);
        }

        to {
            box-shadow: 0 0 15px rgba(126,128,132,0);
        }
    }

    .login-title {
        text-align: center;
        margin: 0 auto 40px auto;
        color: #303133;
    }

    .login-box .el-button {
        width: 100%;
        background-color: #24D994;
        border-color: #24D994;
        font-size: 18px;
        padding: 10px 20px;
        margin-top: 10px;
    }

        .login-box .el-button.is-round {
            height: 40px;
            border-radius: 40px;
            -webkit-border-radius: 40px;
            -moz-border-radius: 40px;
        }

    .login-input .el-input__inner {
        border-radius: 40px;
        -webkit-border-radius: 40px;
        -moz-border-radius: 40px;
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        opacity: 0.6;
        background: #354653;
        border-color: #354653;
        color: #fff;
    }

    .login-input .el-input__icon {
        font-size: 16px;
    }

    .login-box .el-form-item {
        margin-bottom: 10px;
    }

    login-box .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus {
        background-color: #ffc5c5;
        border-color: #ffc5c5;
    }

    .copyinfo {
        margin-top: 20px;
        color: #7e7e7e;
        font-size: 10px;
        text-align: center;
    }

    .subbtn {
        color: #fff;
        cursor: pointer;
    }

        .subbtn:hover {
            color: #24A2FF;
            cursor: pointer;
        }

    .el-form-item__error {
        padding-top: 0;
        margin-left: 20px;
        transform: scale(0.8);
        transform-origin: 0 0;
    }

    @keyframes realanima {
        from {
            transform: translateX(-100px);
            opacity: 0;
        }

        to {
            transform: translateX(0);
            opacity: 1;
        }
    }
</style>
